import * as React from 'react';
import * as ReactDOM from 'react-dom';

import ThemeProvider from './common/styles/ThemeProvider';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

import './common/styles/globalStyles';
import { addBrowserClassName } from './common/helpers';
addBrowserClassName();

ReactDOM.render(
  (
    <ThemeProvider>
      <App />
    </ThemeProvider>
  ),
  document.getElementById( 'root' ) as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx